export default class ItemModel {
  constructor({ itemData }) {
    this._itemData = itemData || {};
  }

  issueDetails = () => {
    return this._itemData?.issue_details;
  };
  stagesData = () => {
    return this._itemData?.stagesData?.map((stageData) => {
      return {
        tasks: () => {
          return stageData.tasks;
        },
        signatures: () => {
          return stageData.signatureDetails;
        },
        customFields: () => {
          return stageData.customFields;
        },
        attachments: () => {
          return stageData.attachments;
        },
        stageAssignees: () => {
          return stageData.stageAssignees;
        },
        name: stageData.name,
        due_date: stageData.due_date,
        isCurrentStage: stageData.isCurrentStage,
      };
    });
  };

  name = () => {
    return this._itemData.name;
  };

  requiresComment = () => {
    return this._itemData.requiresComment;
  };

  type = () => {
    const type = this._itemData?.issue_details?.type;
    if (type === 'issue') return 'issue';
    if (type === 'change_control') return 'changeControl';
    return type;
  };

  getCurrentStageData() {
    return this._itemData?.stagesData?.filter((stage) => stage.isCurrentStage);
  }

  currentStepData = () => {
    const currentStageData = this.getCurrentStageData();
    if (currentStageData) {
      const workflows = currentStageData[0]?.workflows;
      const currentStep = workflows?.flatMap((wf) => wf.workflowSteps?.filter((step) => step.isCurrentStep));
      const stepData = currentStep ? currentStep[0] : {};
      return {
        stepName: stepData?.name,
        signatureReason: stepData?.signatureReason,
        workFlowStepStatus: stepData?.workflowStepStatus,
      };
    }
    return [];
  };

  isCurrentStepInApprovalPending = () => {
    const workFlowStepStatus = this.currentStepData()?.workFlowStepStatus?.status;
    return workFlowStepStatus === 'active';
  };
}
